var map = {
	"./ATB.png": 7384,
	"./Mitutoyo2.png": 2241,
	"./aws-logo.png": 9308,
	"./itesm.png": 4673,
	"./mitutoyo-logo.png": 6546,
	"./mitutoyo.png": 1999,
	"./noah-azul.svg": 1891,
	"./noah.svg": 1781,
	"./oneila.png": 7689,
	"./pedraza.png": 9427,
	"./steren.png": 4365,
	"./steren2.png": 9594
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 501;